<template>
    <div class="main-container">
        <div class="button-area">
            <el-button @click="closeTimetableDialg" type="gray" size="small"><i class="el-icon-back"></i>&nbsp;返回</el-button>
            <el-badge :is-dot="finalUpdateInfo.length > 0" style="margin: 0 10px 0 10px">
                <el-button @click="saveTimetable" type="primary" size="small"><i class="el-icon-circle-check"></i>&nbsp;保存</el-button>
            </el-badge>
            <el-button @click="showRemark" type="success" size="small"><i class="el-icon-reading"></i>&nbsp;备注</el-button>
            <el-button @click="showSiteTimetable" type="warning" size="small"><i class="el-icon-date"></i>&nbsp;教室课表</el-button>

            <el-tag v-show="finalUpdateInfo.length > 0" type="danger" style="float:right;">课表尚未保存</el-tag>
        </div>
        <el-container id="timetable-container">
            <el-aside width="250px">
                <el-input style="width:240px; margin-top:10px;" placeholder="班级查询" clearable v-model="treeFilterText"></el-input>
                <div ref="mainDiv" id="tree-container" :style="{width:'240px', height:mainDivHeight-20+'px', marginTop:'10px', overflow:'auto'}">
                    <el-tree ref="classTree" :data="classTreeData" node-key="id" :props="defaultProps"
                        :default-expanded-keys="['0']" @node-click="handleNodeClick" :filter-node-method="filterNode">
                    </el-tree>
                </div>
            </el-aside>
            <el-main>
                <table class="timetable timetableHead">
                    <tr>
                        <td class="cellTitle separetor" style="width:13.15%;">{{ curClassName }}</td>
                        <td v-for="colNum in semesterBaseParams.weekDayNum"
                            class="cellTitle separetor"
                            :style="{width: 86.85/semesterBaseParams.weekDayNum + '%'}">{{ semesterBaseParams.weekDayName[colNum-1] }}
                        </td>
                    </tr>
                </table>
                <div id="timetable-area" :style="{height:mainDivHeight-30+'px'}">
                    <table class="timetable">
                        <tr v-if="semesterBaseParams.forenoonNum > 0">
                            <td class="cellTitle separetor" :rowspan="semesterBaseParams.forenoonNum" style="width:3%;">上<br/><br/>午</td>
                            <td class="cellTitle" style="width:2%;">1</td>
                            <td class="cellTitle" style="width:8%">
                                {{ semesterBaseParams.timeOrderInfo[0].time }}
                            </td>
                            <td v-for="colNum in semesterBaseParams.weekDayNum"
                                class="timetableContent"
                                :id="timetableCellPrefix + ((colNum-1)*semesterBaseParams.totalNum)"
                                :style="{width: 87/semesterBaseParams.weekDayNum + '%'}"
                                :title="formatTimetableTitle((colNum-1)*semesterBaseParams.totalNum)"
                                v-html="formatTimetableHtml((colNum-1)*semesterBaseParams.totalNum)"
                                @mouseenter="handleCellMouseEnter"
                                @mouseleave="handleCellMouseLeave">
                            </td>
                        </tr>
                        <template v-if="semesterBaseParams.forenoonNum > 1">
                            <tr v-for="rowNum in semesterBaseParams.forenoonNum-1">
                                <td :class="rowNum < semesterBaseParams.forenoonNum-1 ? 'cellTitle' : 'cellTitle separetor'">
                                    {{ rowNum + 1 }}
                                </td>
                                <td :class="rowNum < semesterBaseParams.forenoonNum-1 ? 'cellTitle' : 'cellTitle separetor'">
                                    {{ semesterBaseParams.timeOrderInfo[rowNum].time }}
                                </td>
                                <td v-for="colNum in semesterBaseParams.weekDayNum"
                                    :class="rowNum < semesterBaseParams.forenoonNum-1 ? 'timetableContent' : 'timetableContent separetor'"
                                    :id="timetableCellPrefix + ((colNum-1)*semesterBaseParams.totalNum + rowNum)"
                                    :title="formatTimetableTitle((colNum-1)*semesterBaseParams.totalNum + rowNum)"
                                    v-html="formatTimetableHtml((colNum-1)*semesterBaseParams.totalNum + rowNum)"
                                    @mouseenter="handleCellMouseEnter"
                                    @mouseleave="handleCellMouseLeave">
                                </td>
                            </tr>
                        </template>
                        <tr v-if="semesterBaseParams.noonNum > 0">
                            <td class="cellTitle separetor" :rowspan="semesterBaseParams.noonNum">中<br /><br />午</td>
                            <td class="cellTitle">
                                {{ semesterBaseParams.forenoonNum + 1 }}
                            </td>
                            <td class="cellTitle">
                                {{ semesterBaseParams.timeOrderInfo[semesterBaseParams.forenoonNum].time }}
                            </td>
                            <td v-for="colNum in semesterBaseParams.weekDayNum"
                                class="timetableContent"
                                :id="timetableCellPrefix + ((colNum-1)*semesterBaseParams.totalNum + semesterBaseParams.forenoonNum)"
                                :title="formatTimetableTitle((colNum-1)*semesterBaseParams.totalNum + semesterBaseParams.forenoonNum)"
                                v-html="formatTimetableHtml((colNum-1)*semesterBaseParams.totalNum + semesterBaseParams.forenoonNum)"
                                @mouseenter="handleCellMouseEnter"
                                @mouseleave="handleCellMouseLeave">
                            </td>
                        </tr>
                        <template v-if="semesterBaseParams.noonNum > 1">
                            <tr v-for="rowNum in semesterBaseParams.noonNum-1">
                                <td :class="rowNum < semesterBaseParams.noonNum-1 ? 'cellTitle' : 'cellTitle separetor'">
                                    {{ semesterBaseParams.forenoonNum + semesterBaseParams.rowNum + 1 }}
                                </td>
                                <td :class="rowNum < semesterBaseParams.noonNum-1 ? 'cellTitle' : 'cellTitle separetor'">
                                    {{ semesterBaseParams.timeOrderInfo[semesterBaseParams.forenoonNum+rowNum].time }}
                                </td>
                                <td v-for="colNum in semesterBaseParams.weekDayNum"
                                    :class="rowNum < semesterBaseParams.noonNum-1 ? 'timetableContent' : 'timetableContent separetor'"
                                    :id="timetableCellPrefix + ((colNum-1)*semesterBaseParams.totalNum + semesterBaseParams.forenoonNum + rowNum)"
                                    :title="formatTimetableTitle((colNum-1)*semesterBaseParams.totalNum + semesterBaseParams.forenoonNum + rowNum)"
                                    v-html="formatTimetableHtml((colNum-1)*semesterBaseParams.totalNum + semesterBaseParams.forenoonNum + rowNum)"
                                    @mouseenter="handleCellMouseEnter"
                                    @mouseleave="handleCellMouseLeave">
                                </td>
                            </tr>
                        </template>
                        <tr v-if="semesterBaseParams.afternoonNum > 0">
                            <td class="cellTitle separetor" :rowspan="semesterBaseParams.afternoonNum">下<br/><br/>午</td>
                            <td class="cellTitle">
                                {{ semesterBaseParams.forenoonNum + semesterBaseParams.noonNum + 1 }}
                            </td>
                            <td class="cellTitle">
                                {{ semesterBaseParams.timeOrderInfo[semesterBaseParams.forenoonNum+semesterBaseParams.noonNum].time }}
                            </td>
                            <td v-for="colNum in semesterBaseParams.weekDayNum"
                                class="timetableContent"
                                :id="timetableCellPrefix + ((colNum-1)*semesterBaseParams.totalNum + semesterBaseParams.forenoonNum + semesterBaseParams.noonNum)"
                                :title="formatTimetableTitle((colNum-1)*semesterBaseParams.totalNum + semesterBaseParams.forenoonNum + semesterBaseParams.noonNum)"
                                v-html="formatTimetableHtml((colNum-1)*semesterBaseParams.totalNum + semesterBaseParams.forenoonNum + semesterBaseParams.noonNum)"
                                @mouseenter="handleCellMouseEnter"
                                @mouseleave="handleCellMouseLeave">
                            </td>
                        </tr>
                        <template v-if="semesterBaseParams.afternoonNum > 1">
                            <tr v-for="rowNum in semesterBaseParams.afternoonNum-1">
                                <td :class="rowNum < semesterBaseParams.afternoonNum-1 ? 'cellTitle' : 'cellTitle separetor'">
                                    {{ semesterBaseParams.forenoonNum + semesterBaseParams.noonNum + rowNum + 1 }}
                                </td>
                                <td :class="rowNum < semesterBaseParams.afternoonNum-1 ? 'cellTitle' : 'cellTitle separetor'">
                                    {{ semesterBaseParams.timeOrderInfo[semesterBaseParams.forenoonNum+semesterBaseParams.noonNum+rowNum].time }}
                                </td>
                                <td v-for="colNum in semesterBaseParams.weekDayNum"
                                    :class="rowNum < semesterBaseParams.afternoonNum-1 ? 'timetableContent' : 'timetableContent separetor'"
                                    :id="timetableCellPrefix + ((colNum-1)*semesterBaseParams.totalNum + semesterBaseParams.forenoonNum + semesterBaseParams.noonNum + rowNum)"
                                    :title="formatTimetableTitle((colNum-1)*semesterBaseParams.totalNum + semesterBaseParams.forenoonNum + semesterBaseParams.noonNum + rowNum)"
                                    v-html="formatTimetableHtml((colNum-1)*semesterBaseParams.totalNum + semesterBaseParams.forenoonNum + semesterBaseParams.noonNum + rowNum)"
                                    @mouseenter="handleCellMouseEnter"
                                    @mouseleave="handleCellMouseLeave">
                                </td>
                            </tr>
                        </template>
                        <tr v-if="semesterBaseParams.eveningNum > 0">
                            <td class="cellTitle" :rowspan="semesterBaseParams.eveningNum">晚<br /><br />上</td>
                            <td class="cellTitle">
                                {{ semesterBaseParams.forenoonNum + semesterBaseParams.noonNum + semesterBaseParams.afternoonNum + 1}}
                            </td>
                            <td class="cellTitle">
                                {{ semesterBaseParams.timeOrderInfo[semesterBaseParams.forenoonNum+semesterBaseParams.noonNum+semesterBaseParams.afternoonNum].time }}
                            </td>
                            <td v-for="colNum in semesterBaseParams.weekDayNum"
                                class="timetableContent"
                                :id="timetableCellPrefix + ((colNum-1)*semesterBaseParams.totalNum + semesterBaseParams.forenoonNum + semesterBaseParams.noonNum + semesterBaseParams.afternoonNum)"
                                :title="formatTimetableTitle((colNum-1)*semesterBaseParams.totalNum + semesterBaseParams.forenoonNum + semesterBaseParams.noonNum + semesterBaseParams.afternoonNum)"
                                v-html="formatTimetableHtml((colNum-1)*semesterBaseParams.totalNum + semesterBaseParams.forenoonNum + semesterBaseParams.noonNum + semesterBaseParams.afternoonNum)"
                                @mouseenter="handleCellMouseEnter"
                                @mouseleave="handleCellMouseLeave">
                            </td>
                        </tr>
                        <template v-if="semesterBaseParams.eveningNum > 1">
                            <tr v-for="rowNum in semesterBaseParams.eveningNum-1">
                                <td class="cellTitle">
                                    {{ semesterBaseParams.forenoonNum + semesterBaseParams.noonNum + semesterBaseParams.afternoonNum + rowNum + 1 }}
                                </td>
                                <td class="cellTitle">
                                    {{ semesterBaseParams.timeOrderInfo[semesterBaseParams.forenoonNum+semesterBaseParams.noonNum+semesterBaseParams.afternoonNum+rowNum].time }}
                                </td>
                                <td v-for="colNum in semesterBaseParams.weekDayNum"
                                    class="timetableContent"
                                    :id="timetableCellPrefix + ((colNum-1)*semesterBaseParams.totalNum + semesterBaseParams.forenoonNum + semesterBaseParams.noonNum + semesterBaseParams.afternoonNum + rowNum)"
                                    :title="formatTimetableTitle((colNum-1)*semesterBaseParams.totalNum + semesterBaseParams.forenoonNum + semesterBaseParams.noonNum + semesterBaseParams.afternoonNum + rowNum)"
                                    v-html="formatTimetableHtml((colNum-1)*semesterBaseParams.totalNum + semesterBaseParams.forenoonNum + semesterBaseParams.noonNum + semesterBaseParams.afternoonNum + rowNum)"
                                    @mouseenter="handleCellMouseEnter"
                                    @mouseleave="handleCellMouseLeave">
                                </td>
                            </tr>
                        </template>
                    </table>
                </div>
            </el-main>
        </el-container>

        <!-- 左键菜单 -->
        <div id="rightButtonMenu" @mouseleave="hideRightButtonMenu">
            <el-tooltip class="item" effect="dark" content="课程信息变更" placement="top">
                <el-button type="primary" icon="el-icon-setting" circle @click="changeCourseInfo"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="教师课表" placement="top">
                <el-button type="warning" icon="el-icon-date" circle @click="showTeaTimetable"></el-button>
            </el-tooltip>
        </div>

        <el-dialog :title="remarkDialogTitle"
            :visible.sync="remarkDialogVisible"
            v-if="remarkDialogVisible"
            width="500px" top="250px" append-to-body>
            <div style="height:285px;">
                <remark ref="remark" @closeRemarkDialog="closeRemarkDialog"></remark>
            </div>
        </el-dialog>

        <el-dialog title="课程信息设置"
            :visible.sync="courseSettingDialogVisible"
            v-if="courseSettingDialogVisible"
            width="1000px" top="250px" append-to-body>
            <div :style="{height: courseSettingDialogHeight + 'px'}">
                <courseSetting ref="courseSetting"
                    @updateCourseSettingDialogHeight="updateCourseSettingDialogHeight"
                    @updateChangeCourseInfo="updateChangeCourseInfo"
                    @batchUpdateChangeCourseInfo="batchUpdateChangeCourseInfo"
                    @closeChangeCourseInfoDialog="closeChangeCourseInfoDialog"></courseSetting>
            </div>
        </el-dialog>

        <el-dialog title="场地课表"
            :visible.sync="siteTimetableDialogVisible"
            v-if="siteTimetableDialogVisible"
            width="1300px" top="70px" append-to-body>
            <div style="height:660px;">
                <siteTimetable ref="siteTimetable"></siteTimetable>
            </div>
        </el-dialog>

        <el-dialog title="教师课表"
            :visible.sync="teaTimetableDialogVisible"
            v-if="teaTimetableDialogVisible"
            width="1300px" top="70px" append-to-body>
            <div style="height:660px;">
                <teaTimetable ref="teaTimetable"></teaTimetable>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { confirmMsg, showNotify } from "utils/message";
    import { globalConfig } from "static/config";
    import * as commonTools from "utils/timetableCommon";
    import remark from 'views/timetableManage/arrange/remark.vue';
    import customCourse from 'views/timetableManage/arrange/customCourse.vue';
    import courseSetting from 'views/timetableManage/arrange/courseSetting.vue';
    import sitePreConfig from 'views/timetableManage/arrange/sitePreConfig.vue';
    import siteTimetable from 'views/timetableManage/arrange/siteTimetable.vue';
    import teaTimetable from 'views/timetableManage/arrange/teaTimetable.vue';

    export default {
        props: ['curSemesterCode'],
        components: {
            remark,
            courseSetting,
            sitePreConfig,
            siteTimetable,
            teaTimetable,
        },
        data() {
            return {
                userRole: [],
                queryForm: {
                    semesterCode: null,
                    classCode: null,
                },
                classTreeData: [],
                mainDivHeight: 500,
                curClassName: null,
                curClassStuNum: 0,//当前班级学生人数
                treeFilterText: null,
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                //学期基本参数
                semesterBaseParams: {
                    weekDayNum: null,//每周天数
                    weekDayName: null,//星期几中文名称
                    forenoonNum: null,//上午节数
                    noonNum: null,//中午节数
                    afternoonNum: null,//下午节数
                    eveningNum: null,//晚上节数
                    totalNum: null,//总节数
                    semesterWeekNum: null,//学期周数
                    teachingWeekNum: null,//教学周数
                    timeOrderInfo: [],//时间序列信息
                    oddWeekArray: [],//单周信息
                    evenWeekArray: [],//双周信息
                    allowArrangeState: false,//用于判断是否排课截止时间内
                },
                lockedState: false,//用于判断排课锁定状态
                //课表信息
                timetableInfo: [],//课表信息
                timetableOperateState: [],//用于标记验证单元格后的单元格可操作状态
                teachingPlanInfo: [],//教学计划信息
                adjuestOrderInfo: [],//已调课时间序列
                finalUpdateInfo: [],//最终待更新课表信息
                //已用时间序列查询信息
                usedOrderQueryInfo: {
                    semesterCode: null,
                    classCode: null,
                    teaCode: null,//查询的教师编号
                    siteCode: null,//查询的场地编号
                    siteType: null,//查询的场地类型
                    siteDept: null,//查询的场地所属开课部门
                },
                teaUsedOrderInfo: null,//教师使用情况信息
                siteUsedOrderInfo: null,//场地使用情况信息
                mergeClassSetInfo: null,//合班设置信息
                mergeClassCourseInfo: null,//合班课程排课情况信息
                //待过滤相关课程信息
                filterCourseInfo: {
                    userAuthInfo: [],//用户排课权限信息
                    noAuthLimit: false,//用于判断是否拥有全部操作权限（true：无限制 / false：有限制）
                    keepInfoAuth: true,//用于判断保留的信息类型（true：有权操作的内容 / false：无权操作的内容）
                    isAdmin: false,//用于判断是否管理员权限
                    courseInfo: null,
                },
                //待验证相关课程信息
                verifyCourseInfo: {
                    semesterCode: null,
                    teachingWeek: null,
                    classCode: null,
                    className: null,
                    infoType: 'timetable',
                    isVerify: false,
                    courseList: [],
                },
                //待更新的课表和未排课程信息
                updateCourseInfo: {
                    // timetable: [],//课表内容
                    teachingPlan: [],//未排课程内容
                },
                //课表操作相关参数
                timetableCellPrefix: 'timetableCell_',
                teachingPlanCellPrefix: 'courseCell_',
                separator: '｜',
                curSelectCell: null,//当前选中的单元格信息
                curTargetCell: {//当前鼠标位置的单元格信息
                    id: null,
                },
                oriTilteArray: [],//验证课表单元格可用状态时，用于保存原始title信息
                curTargetTitle: null,
                cellOriColor: null,
                cellColor: {
                    normal: '#FFFFFF',
                    foucs: '#FFE48D',
                    allow: '#E7FECB',
                    merge: '#BFEFFF',
                },
                //右键菜单相关参数
                rightBtnSelectId: null,
                //备注对话框标识
                remarkDialogVisible: false,
                remarkDialogTitle: null,
                //课程信息设置对话框标识
                courseSettingDialogVisible: false,
                courseSettingDialogHeight: 120,
                //场地课表对话框标识
                siteTimetableDialogVisible: false,
                //教师课表对话框标识
                teaTimetableDialogVisible: false,
                //全局遮罩层
                loadingMask: null,
            }
        },
        created(){
            window.addEventListener('beforeunload', this.beforeunloadHandler);//刷新或关闭监听
        },
        mounted() {
            this.queryForm.semesterCode = this.curSemesterCode;
            this.verifyCourseInfo.semesterCode = this.curSemesterCode;
            this.init();

            this.$nextTick().then(() => {
                //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
                //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
                this.mainDivHeight = window.innerHeight - this.$refs.mainDiv.offsetTop;
                // 监听窗口大小变化
                let self = this;
                window.onresize = function() {
                    self.mainDivHeight = window.innerHeight - self.$refs.mainDiv.offsetTop;
                };
            });
        },
        watch: {
            treeFilterText(val) {
                this.$refs.classTree.filter(val);
            }
        },
        beforeRouteLeave(to, from, next) {
            // console.log('----------beforeRouteLeave--------刷新或关闭');
            this.beforeunloadHandler();

            this.$nextTick(() => {
                next();
            });
        },
        beforeDestroy() {
            // console.log('----------beforeDestroy--------刷新或关闭');
            this.beforeunloadHandler();
        },
        methods: {
            beforeunloadHandler() {
                // console.log('----------beforeunloadHandler--------刷新或关闭');
                this.handleLockState('all', 'unlock');
                if(this.finalUpdateInfo.length > 0){
                    this.initUsedOrderInfo('force');
                }
                window.removeEventListener('beforeunload', this.beforeunloadHandler);
            },
            init(){
                //获取用户角色
                this.queryUserRole();
                //获取用户排课权限
                this.queryUserAuth();
                //加载班级树
                this.queryTree();
                //初始化空白课表
                this.initBlankTimetable();
                //绑定右键事件
                this.bindRightButtonEvent();
                //初始化教师/场地已用信息
                this.initUsedOrderInfo('auto');
            },
            queryUserRole() {
                this.$api.system.basic.userInfo({}).then((res) => {
                    const userInfo = res.data.data;
                    if (userInfo) {
                        for (let roleCode in userInfo.roles) {
                            // console.log("键：" + roleCode + ",值："+ roleInfo[roleCode]);
                            this.userRole.push(roleCode);

                            if(roleCode === globalConfig.auth.admin){
                                this.filterCourseInfo.isAdmin = true;
                            }
                        }
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },
            queryUserAuth() {
                this.$api.timetableManage.arrange.queryUserAuth({}).then((res) => {
                    const authInfo = res.data.data;
                    this.filterCourseInfo.userAuthInfo = authInfo;
                    let hasAllPubAuth = false;
                    let hasAllMajorAuth = false;
                    for(let i=0; i<authInfo.length; i++){
                        if(authInfo[i].courseType==='01' && authInfo[i].courseDept.indexOf('all')>-1){
                            hasAllPubAuth = true;
                        }
                        if(authInfo[i].courseType==='02' && authInfo[i].courseDept.indexOf('all')>-1){
                            hasAllMajorAuth = true;
                        }
                    }

                    if(hasAllPubAuth && hasAllMajorAuth) this.filterCourseInfo.noAuthLimit = true;
                }).catch((error) => {
                    console.log(error);
                });
            },
            //查询班级树
            queryTree() {
                this.$api.timetableManage.common.queryClassTreeByAuth({
                    data: this.queryForm
                }).then((response) => {
                    this.classTreeData = response.data.data;
                }).catch(error => {
                    console.log(error);
                });
            },
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            //点击node
            handleNodeClick(node) {
                if (node.nodeType==='class' && this.queryForm.classCode!=node.id) {
                    //判断如果切换了班级，解锁原班级锁定状态
                    if(this.queryForm.classCode != ''){
                        this.handleLockState('manual', 'unlock');
                    }

                    if(this.finalUpdateInfo.length > 0){
                        this.$confirm('当前课表修改内容尚未保存，是否需要保存？', '提示', {
                            confirmButtonText: '保存',
                            cancelButtonText: '放弃',
                            showClose: false,
                            customClass: 'confirm-box',
                            type: 'warning'
                        }).then(async () => {
                            await this.saveTimetable();
                            await this.switchClass(node.id, node.label);
                        }).catch(async (data) => {
                            await this.initUsedOrderInfo('force');
                            await this.switchClass(node.id, node.label);
                        });
                    }else{
                        this.switchClass(node.id, node.label);
                    }
                }
            },
            switchClass(courseCode, courseName){
                this.curClassName = courseName;
                this.queryForm.classCode = courseCode;
                this.verifyCourseInfo.classCode = courseCode;
                this.verifyCourseInfo.className = courseName;
                this.verifyLockState();
                this.queryClassCourseArrangeInfo();
                document.getElementById('timetable-container').scrollTop = 0;
            },
            initBlankTimetable() {
                this.$api.timetableManage.common.baseParam({
                    data: this.queryForm
                }).then((res) => {
                    this.semesterBaseParams.weekDayNum = parseInt(res.data.data.baseParam.weekDayNum, 10);
                    this.semesterBaseParams.weekDayName = res.data.data.baseParam.weekDayName.split(',');
                    this.semesterBaseParams.forenoonNum = parseInt(res.data.data.baseParam.forenoonNum, 10);
                    this.semesterBaseParams.noonNum = parseInt(res.data.data.baseParam.noonNum, 10);
                    this.semesterBaseParams.afternoonNum = parseInt(res.data.data.baseParam.afternoonNum, 10);
                    this.semesterBaseParams.eveningNum = parseInt(res.data.data.baseParam.eveningNum, 10);
                    this.semesterBaseParams.totalNum = this.semesterBaseParams.forenoonNum + this.semesterBaseParams.noonNum + this.semesterBaseParams.afternoonNum + this.semesterBaseParams.eveningNum;

                    //生成时间序列信息
                    this.semesterBaseParams.timeOrderInfo = new Array();
                    const timeQuantumArray = res.data.data.baseParam.timeQuantum.split(',');
                    for(let i=1; i<this.semesterBaseParams.weekDayNum+1; i++){
                        for(let j=1; j<this.semesterBaseParams.totalNum+1; j++){
                            let timeOrder = {
                                order: (i<10?'0'+i:''+i) + (j<10?'0'+j:''+j),
                                time: timeQuantumArray[i].split('@')[1]
                            };

                            this.semesterBaseParams.timeOrderInfo.push(timeOrder);
                        }
                    }

                    //生成单双周信息
                    this.semesterBaseParams.semesterWeekNum = res.data.data.baseParam.semesterWeekNum;
                    this.semesterBaseParams.teachingWeekNum = res.data.data.baseParam.teachingWeekNum;
                    for(let i=1; i<parseInt(this.semesterBaseParams.teachingWeekNum, 10)+1; i+=2){
                        this.semesterBaseParams.oddWeekArray.push(i);
                    }
                    for(let i=2; i<parseInt(this.semesterBaseParams.teachingWeekNum, 10)+1; i+=2){
                        this.semesterBaseParams.evenWeekArray.push(i);
                    }

                    this.verifyCourseInfo.teachingWeek = this.semesterBaseParams.teachingWeekNum;
                    this.semesterBaseParams.allowArrangeState = res.data.data.baseParam.allowArrangeState == 'true' ? true : false;
                }).catch((error) => {
                    console.log(error);
                });
            },
            queryClassCourseArrangeInfo() {
                this.showLoadingMask("课表加载中，请稍候...");

                this.$api.timetableManage.arrange.queryClassCourseArrangeInfo({
                    data: this.queryForm
                }).then((response) => {
                    this.curClassStuNum = response.data.data.stuNum;
                    this.timetableInfo = response.data.data.timetableInfo;
                    this.teachingPlanInfo = response.data.data.teachingPlanInfo;
                    //根据未排节数排序
                    this.teachingPlanInfo.sort(commonTools.sortBy('desc', 'unarrangeNum'));
                    this.adjuestOrderInfo = response.data.data.adjuestOrderInfo;
                    this.finalUpdateInfo = [];
                    // console.log(this.curClassStuNum);
                    // console.log(this.timetableInfo);
                    // console.log(this.teachingPlanInfo);
                    // console.log(this.adjuestOrderInfo);
                    this.usedOrderQueryInfo = commonTools.handleUsedRelatedInfo(this.timetableInfo, this.teachingPlanInfo);
                    this.usedOrderQueryInfo.semesterCode = this.queryForm.semesterCode;
                    this.usedOrderQueryInfo.classCode = this.queryForm.classCode;

                    this.queUsedOrderInfo();
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.closeLoadingMask();
                });
            },
            formatTimetableHtml(index){
                let contentStr = '';
                const info = this.timetableInfo[index];

                if(info && info.courseName){
                    contentStr = info.courseName;
                    if (contentStr.indexOf(this.separator)<0 && contentStr.length>13) {
                        contentStr = contentStr.substring(0, 10) + '……';
                    }
                    if (info.teaName) contentStr += '<br/>' + info.teaName;
                    if (info.siteName) contentStr += '<br/>' + info.siteName;
                    if (info.week) contentStr += "<br/>" + commonTools.formatWeekShow(info.week, this.semesterBaseParams.oddWeekArray, this.semesterBaseParams.evenWeekArray);

                    if(info.arrangeState == '2'){//固排
                        document.getElementById('timetableCell_' + index).className += ' blueFont';
                    }
                }

                return contentStr;
            },
            formatTimetableTitle(index){
                let contentStr = '';
                const info = this.timetableInfo[index];

                if(info){
                   //判断单元格排课状态
                   if(info.arrangeState == '3'){//禁排
                       contentStr = '此位置为班级禁排';
                   }else{
                      if(info.courseName){
                          contentStr = info.courseName;
                          if (info.teaName) contentStr += '\n' + info.teaName;
                          if (info.siteName) contentStr += '\n' + info.siteName;
                          if (info.week) contentStr += "\n" + commonTools.formatWeekShow(info.week, this.semesterBaseParams.oddWeekArray, this.semesterBaseParams.evenWeekArray);

                          if(info.arrangeState == '2'){//固排
                              contentStr = '固排课程\n\n' + contentStr;
                          }
                      }
                   }
                }

                return contentStr;
            },
            handleCellMouseEnter(event){
                //判断是否选择了班级
                if(this.queryForm.classCode === null) return;
                //判断是否为选中的单元格
                if(this.curSelectCell && this.curSelectCell.id===event.srcElement.id) return;

                const id = event.srcElement.id;

                //判断教师排课权限
                if(this.judgeUserAuth(id)){
                    this.cellOriColor = $('#' + id).css('background-color');
                    $('#' + id).css('background-color', this.cellColor.foucs);
                }else{
                    if(this.curSelectCell === null){
                        const tempTitle = '该课程没有操作权限\n\n' + $('#' + id).attr('title');
                        $('#' + id).attr('title', tempTitle);
                    }
                }

                this.showTitleInfo(id);
            },
            handleCellMouseLeave(event){
                //判断是否选择了班级
                if(this.queryForm.classCode === null) return;
                //判断是否为选中的单元格
                if(this.curSelectCell && this.curSelectCell.id===event.srcElement.id) return;

                if(this.cellOriColor) {
                    $('#' + event.srcElement.id).css('background-color', this.cellOriColor);
                    this.cellOriColor = null;
                }

                this.hideTitleInfo(event.srcElement.id);
            },
            isAllowOperate(){
                //判断是否已选中了班级
                //是否排课锁定
                //是否管理员或在允许排课时间内
                return this.queryForm.classCode!=null && !this.lockedState && (this.filterCourseInfo.isAdmin || this.semesterBaseParams.allowArrangeState) ? true : false;
            },
            //显示title信息
            showTitleInfo(id){
                //获取title属性的内容
                this.curTargetTitle = $('#' + id).attr('title');

                if(this.curTargetTitle){
                    //设置元素title属性内容为空
                    $('#' + id).attr('title', '');

                    $("body").append("<div id='div_toop'>" + this.curTargetTitle.replace(/\n/g, '<br>') + "</div>");
                    $("#div_toop").css({
                        "position": "absolute",
                        "z-index": 999999,
                        "font-size": 12,
                        "background": "rgba(245, 245, 245, 0.9)",
                        "border": "solid 1px #A9A9A9",
                        "border-radius": "5px",
                        "padding": "5px",
                        "max-width": "200px"
                    });
                    if(id.indexOf(this.timetableCellPrefix) > -1){
                        $('#div_toop').css("top", $('#' + id).offset().top-$('#div_toop').height()+10 + "px");
                    }else{
                        $('#div_toop').css("top", $('#' + id).offset().top-$('#div_toop').height() + "px");
                    }
                    $('#div_toop').css("left", $('#' + id).offset().left-$('#div_toop').width()+10 + "px");
                }
            },
            hideTitleInfo(id){
                if(this.curTargetTitle){
                    const tempTitle = this.curTargetTitle.replace('该课程没有操作权限\n\n', '');
                    $('#' + id).attr('title', tempTitle);
                    this.curTargetTitle = null;
                }
                $("#div_toop").remove();
            },
            //判断教师排课权限（只要有一门课可以操作，视为允许操作单元格）
            judgeUserAuth(id){
                let courseType = null;
                let courseDept = null;
                const curIndex = commonTools.getIndexById(id);
                let hasCourse = false;

                if(id.indexOf(this.timetableCellPrefix) > -1){
                    //判断单元格有内容并且有课程信息
                    if(this.timetableInfo[curIndex] && this.timetableInfo[curIndex].planCode!=''){
                        courseType = this.timetableInfo[curIndex].courseTypeCode;
                        courseDept = this.timetableInfo[curIndex].deptCode;
                        hasCourse = true;
                    }
                }else if(id.indexOf(this.teachingPlanCellPrefix) > -1){
                    //判断单元格有内容并且未安排结束大于0
                    if(this.teachingPlanInfo[curIndex] && this.teachingPlanInfo[curIndex].unarrangeNum>0){
                        courseType = this.teachingPlanInfo[curIndex].courseTypeCode;
                        courseDept = this.teachingPlanInfo[curIndex].deptCode;
                        hasCourse = true;
                    }
                }

                //判断单元格是否有内容
                if(hasCourse){
                    const courseTypeArray = courseType.split(this.separator);
                    const courseDeptArray = courseDept.split(this.separator);
                    const authInfo = this.filterCourseInfo.userAuthInfo;

                    for(let i=0; i<courseTypeArray.length; i++){
                        for(let j=0; j<authInfo.length; j++){
                            //判断课程类型及开课部门是否允许操作
                            if((courseTypeArray[i]=='' || courseTypeArray[i]==authInfo[j].courseType)
                                && (authInfo[j].courseDept.indexOf('all')>-1 || authInfo[j].courseDept.indexOf(courseDeptArray[i])>-1)){
                                return true;
                            }
                        }
                    }
                }else{
                    return true;
                }

                return false;
            },
            bindRightButtonEvent(){
                //显示右键菜单
                let self = this;
                document.oncontextmenu = function(event){
                    let id = event.target.id;
                    self.rightBtnSelectId = id;

                    if(id.indexOf(self.timetableCellPrefix)>-1 || id.indexOf(self.teachingPlanCellPrefix)>-1){
                        //判断教师排课权限
                        if(!self.judgeUserAuth(id)){
                            return false;
                        }

                        //判断单元格是否有内容
                        if($('#' + id).html() != ''){
                            self.showRightButtonMenu(id);
                        }
                    }

                    return false;
                }
            },
            showRightButtonMenu(id){
                $('#' + id).css('background-color', this.cellColor.normal);
                $('#rightButtonMenu').css('width', $('#' + id).css('width'));
                $('#rightButtonMenu').css('height', $('#' + id).css('height'));
                $('#rightButtonMenu').css('top', $('#' + id).offset().top);
                $('#rightButtonMenu').css('left', $('#' + id).offset().left);
                $('#rightButtonMenu').show();
            },
            hideRightButtonMenu(){
                $('#rightButtonMenu').hide();
            },
            changeCourseInfo(){
                this.hideRightButtonMenu();

                //判断课表是否允许操作
                if(!this.isAllowOperate()){
                    this.alertMsg('当前班级课表暂时无法操作');
                    return;
                }

                const index = commonTools.getIndexById(this.rightBtnSelectId);

                //判断是否为课表单元格
                if(this.rightBtnSelectId.indexOf(this.timetableCellPrefix) > -1){
                    if(this.timetableInfo[index].arrangeState === '2'){
                        this.alertMsg('该课程为固排课程，无法操作！');
                        return;
                    }

                    if(commonTools.isAdjust(this.adjuestOrderInfo, this.timetableInfo[index].timeOrder)){
                        this.alertMsg('该课程已进行调课，无法操作！');
                        return;
                    }
                }

                this.courseSettingDialogVisible = true;
                this.$nextTick().then(() => {
                    this.$refs.courseSetting.cellInfo = JSON.parse(JSON.stringify(this.timetableInfo[index]));
                    //获取无操作权限的授课计划编号
                    commonTools.setFilterCourseInfo(this.filterCourseInfo, this.timetableInfo[index], false);
                    let noAuthPlanCode = commonTools.filterContent(this.filterCourseInfo, 'planCode');
                    this.$refs.courseSetting.noAuthPlanCodeArray = noAuthPlanCode.split(this.separator);
                    this.$refs.courseSetting.queryForm.semesterCode = this.queryForm.semesterCode;
                    this.$refs.courseSetting.queryForm.classCode = this.queryForm.classCode;
                    this.$refs.courseSetting.teachingWeekNum = this.semesterBaseParams.teachingWeekNum;
                    this.$refs.courseSetting.oddWeekArray = this.semesterBaseParams.oddWeekArray;
                    this.$refs.courseSetting.evenWeekArray = this.semesterBaseParams.evenWeekArray;
                    this.$refs.courseSetting.parseCourseInfo();
                });
            },
            updateCourseSettingDialogHeight(height){
                this.courseSettingDialogHeight = height;
            },
            async updateChangeCourseInfo(cellInfo){
                const index = commonTools.getIndexById(this.rightBtnSelectId);

                //重置待验证课表信息
                this.verifyCourseInfo.isVerify = true;
                this.verifyCourseInfo.courseList.length = 0;
                //处理待验证课程信息
                commonTools.setFilterCourseInfo(this.filterCourseInfo, this.timetableInfo[index], true);
                commonTools.addVerifyCourseInfo('del', this.filterCourseInfo.courseInfo.timeOrder, this.verifyCourseInfo, true, this.filterCourseInfo);
                commonTools.setFilterCourseInfo(this.filterCourseInfo, cellInfo, true);
                commonTools.addVerifyCourseInfo('add', this.filterCourseInfo.courseInfo.timeOrder, this.verifyCourseInfo, true, this.filterCourseInfo);
                //验证排课信息并处理Redis信息
                if(await this.verifyCourseArrange()){
                    //处理课表信息
                    this.handleFinalUpdateInfo(cellInfo);
                    this.timetableInfo[index] = cellInfo;
                    this.courseSettingDialogVisible = false;
                }
            },
            async batchUpdateChangeCourseInfo(cellInfo){
                const index = commonTools.getIndexById(this.rightBtnSelectId);

                //用于保存最终更新课表的课程信息
                let finalCourseInfo = [];
                let courseInfo = {
                    index: index,
                    cellInfo: cellInfo
                };
                finalCourseInfo.push(courseInfo);

                //重置待验证课表信息
                this.verifyCourseInfo.isVerify = true;
                this.verifyCourseInfo.courseList.length = 0;

                //处理待验证课程信息
                commonTools.setFilterCourseInfo(this.filterCourseInfo, this.timetableInfo[index], true);
                commonTools.addVerifyCourseInfo('del', this.filterCourseInfo.courseInfo.timeOrder, this.verifyCourseInfo, true, this.filterCourseInfo);
                commonTools.setFilterCourseInfo(this.filterCourseInfo, cellInfo, true);
                commonTools.addVerifyCourseInfo('add', this.filterCourseInfo.courseInfo.timeOrder, this.verifyCourseInfo, true, this.filterCourseInfo);

                //获取当前单元格修改的信息
                const tempCellInfo = commonTools.filterAllContent(this.filterCourseInfo);
                const curPlanCodeArray = tempCellInfo.planCode.split(this.separator);
                const curTeaCodeArray = tempCellInfo.teaCode.split(this.separator);
                const curTeaNameArray = tempCellInfo.teaName.split(this.separator);
                const curSiteCodeArray = tempCellInfo.siteCode.split(this.separator);
                const curSiteNameArray = tempCellInfo.siteName.split(this.separator);
                const curWeekArray = tempCellInfo.week.split(this.separator);
                const curWeekDetailArray = tempCellInfo.weekDetail.split(this.separator);
                //遍历课表信息，查询相同课程
                for(let i=0; i<this.timetableInfo.length; i++){
                    //当前单元格课程信息不做处理
                    if(i === index) continue;

                    let hasSameCourse = false;
                    let finalCellInfo = JSON.parse(JSON.stringify(this.timetableInfo[i]));
                    const tempPlanCodeArray = this.timetableInfo[i].planCode.split(this.separator);
                    const tempTeaCodeArray = this.timetableInfo[i].teaCode.split(this.separator);
                    const tempTeaNameArray = this.timetableInfo[i].teaName.split(this.separator);
                    const tempSiteCodeArray = this.timetableInfo[i].siteCode.split(this.separator);
                    const tempSiteNameArray = this.timetableInfo[i].siteName.split(this.separator);
                    const tempWeekArray = this.timetableInfo[i].week.split(this.separator);
                    const tempWeekDetailArray = this.timetableInfo[i].weekDetail.split(this.separator);
                    for(let j=0; j<tempPlanCodeArray.length; j++){
                        for(let k=0; k<curPlanCodeArray.length; k++){
                            //判断是否相同课程
                            if(tempPlanCodeArray[j] === curPlanCodeArray[k]){
                                tempTeaCodeArray[j] = curTeaCodeArray[k];
                                tempTeaNameArray[j] = curTeaNameArray[k];
                                tempSiteCodeArray[j] = curSiteCodeArray[k];
                                tempSiteNameArray[j] = curSiteNameArray[k];
                                tempWeekArray[j] = curWeekArray[k];
                                tempWeekDetailArray[j] = curWeekDetailArray[k];

                                hasSameCourse = true;
                            }
                        }
                    }

                    if(hasSameCourse === true){
                        //重新拼接课程信息
                        let tempSeparator = '';
                        let finalPlanCode = '';
                        let finalTeaCode = '';
                        let finalTeaName = '';
                        let finalSiteCode = '';
                        let finalSiteName = '';
                        let finalWeek = '';
                        let finalWeekDetail = '';
                        for(let j=0; j<tempPlanCodeArray.length; j++){
                            finalPlanCode += tempSeparator + tempPlanCodeArray[j];
                            finalTeaCode += tempSeparator + tempTeaCodeArray[j];
                            finalTeaName += tempSeparator + tempTeaNameArray[j];
                            finalSiteCode += tempSeparator + tempSiteCodeArray[j];
                            finalSiteName += tempSeparator + tempSiteNameArray[j];
                            finalWeek += tempSeparator + tempWeekArray[j];
                            finalWeekDetail += tempSeparator + tempWeekDetailArray[j];

                            tempSeparator = this.separator;
                        }

                        //检查单元格内拼接课程是否周次冲突
                        const weekArray = commonTools.convertWeekStrToArray(finalWeek, false);
                        let existWeekArray = [];
                        let isConflict = false;
                        for(let j=0; j<weekArray.length; j++){
                            if(existWeekArray.indexOf(weekArray[j]) > -1){
                                isConflict = true;
                                break;
                            }

                            existWeekArray.push(weekArray[j]);
                        }

                        if(isConflict === false){
                            finalCellInfo.planCode = finalPlanCode;
                            finalCellInfo.teaCode = finalTeaCode;
                            finalCellInfo.teaName = finalTeaName;
                            finalCellInfo.siteCode = finalSiteCode;
                            finalCellInfo.siteName = finalSiteName;
                            finalCellInfo.week = finalWeek;
                            finalCellInfo.weekDetail = finalWeekDetail;
                            let courseInfo = {
                                index: i,
                                cellInfo: finalCellInfo
                            };
                            finalCourseInfo.push(courseInfo);

                            //处理待验证课程信息
                            commonTools.setFilterCourseInfo(this.filterCourseInfo, finalCellInfo, true);
                            commonTools.addVerifyCourseInfo('del', this.filterCourseInfo.courseInfo.timeOrder, this.verifyCourseInfo, true, this.filterCourseInfo);
                            commonTools.setFilterCourseInfo(this.filterCourseInfo, finalCellInfo, true);
                            commonTools.addVerifyCourseInfo('add', this.filterCourseInfo.courseInfo.timeOrder, this.verifyCourseInfo, true, this.filterCourseInfo);
                        }else{
                            this.alertMsg('保存失败，' + commonTools.formatTimeOrderShow(finalCellInfo.timeOrder, this.semesterBaseParams) + '上课时间存在冲突！');
                            return;
                        }
                    }
                }

                //验证排课信息并处理Redis信息
                if(await this.verifyCourseArrange()){
                    //处理课表信息
                    for(let i=0; i<finalCourseInfo.length; i++){
                        this.handleFinalUpdateInfo(finalCourseInfo[i].cellInfo);
                        this.timetableInfo[finalCourseInfo[i].index] = finalCourseInfo[i].cellInfo;
                    }
                    this.courseSettingDialogVisible = false;
                }
            },
            closeChangeCourseInfoDialog(){
                this.courseSettingDialogVisible = false;
            },
            async saveTimetable(){
                if(this.finalUpdateInfo.length === 0){
                    this.$message('没有需要保存的课表信息');
                    return;
                }

                this.showLoadingMask("班级课表保存中，请稍候...");
                const params = {
                    semesterCode: this.queryForm.semesterCode,
                    classCode: this.queryForm.classCode,
                    semesterWeek: this.semesterBaseParams.semesterWeekNum,
                    teachingPlan: this.teachingPlanInfo,
                    timetableInfo: this.finalUpdateInfo
                };
                await this.$api.timetableManage.arrange.saveTimetable({
                    data: params
                }).then(response => {
                    if(response.data.data.state = 'success'){
                        showNotify('成功', '保存成功', 'success', 1500);
                       this.finalUpdateInfo = [];
                    }else{
                        showNotify('错误', '保存失败', 'error', 3000);
                    }
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.closeLoadingMask();
                });
            },
            async verifyCourseArrange(){
                let isUseable = false;//校验结果 true:可用/false不可用

                await this.$api.timetableManage.arrange.verifyCourseArrange({
                    data: this.verifyCourseInfo
                }).then(response => {
                    if(response.data.data.isUseable == 'true'){
                        isUseable = true;
                        this.verifyCourseInfo.courseList.length = 0;
                    }else{
                        this.$alert(response.data.data.msg, '提示', {
                            confirmButtonText: '确定',
                        });
                    }
                }).catch(error => {
                    console.log(error);
                });

                return isUseable;
            },
            handleFinalUpdateInfo(cell){
                let isExist = false;
                let index = -1;

                for(let i=0; i<this.finalUpdateInfo.length; i++){
                    if(this.finalUpdateInfo[i].timeOrder === cell.timeOrder){
                        isExist = true;
                        index = i;
                        break;
                    }
                }

                if(isExist){
                    this.finalUpdateInfo[index] = cell;
                }else{
                    this.finalUpdateInfo.push(cell);
                }
            },
            async closeTimetableDialg(){
                this.handleLockState('manual', 'unlock');

                if(this.finalUpdateInfo.length > 0){
                    this.$confirm('当前课表修改内容尚未保存，是否需要保存？', '提示', {
                        confirmButtonText: '保存',
                        cancelButtonText: '放弃',
                        showClose: false,
                        customClass: 'confirm-box',
                        type: 'warning'
                    }).then(async () => {
                        await this.saveTimetable();
                        await this.$emit("closeTimetableDialg");
                    }).catch(async (data) => {
                        await this.initUsedOrderInfo('force');
                        await this.$emit("closeTimetableDialg");
                    });
                }else{
                    this.$emit("closeTimetableDialg");
                }
            },
            showRemark(){
                if(!this.queryForm.classCode){
                    this.alertMsg('请先选择一个班级');
                    return;
                }

                this.remarkDialogTitle = this.curClassName + '课表备注';
                this.remarkDialogVisible = true;
                this.$nextTick().then(() => {
                    this.$refs.remark.curdForm.semesterCode = this.queryForm.semesterCode;
                    this.$refs.remark.curdForm.classCode = this.queryForm.classCode;
                });

            },
            closeRemarkDialog(){
                this.remarkDialogVisible = false;
            },
            showSiteTimetable(){
                this.siteTimetableDialogVisible = true;
                this.$nextTick().then(() => {
                    this.$refs.siteTimetable.queryForm.semesterCode = this.curSemesterCode;
                    this.$refs.siteTimetable.mainDivHeight = 550;
                });
            },
            showTeaTimetable(){
                const curIndex = commonTools.getIndexById(this.rightBtnSelectId);
                let teaCode;
                if(this.rightBtnSelectId.indexOf(this.timetableCellPrefix) > -1){
                    teaCode = this.timetableInfo[curIndex].teaCode;
                }else{
                    teaCode = this.teachingPlanInfo[curIndex].teaCode;
                }
                this.hideRightButtonMenu();
                this.teaTimetableDialogVisible = true;
                this.$nextTick().then(() => {
                    this.$refs.teaTimetable.queryForm.semesterCode = this.curSemesterCode;
                    this.$refs.teaTimetable.teaCodeInfo = teaCode;
                    this.$refs.teaTimetable.mainDivHeight = 550;
                });
            },
            async initUsedOrderInfo(type){
                if(type === 'manual'){
                    this.showLoadingMask('使用情况重置中，请稍候...');
                }else if(type === 'auto'){
                    this.showLoadingMask('信息加载中，请稍候...');
                }else if(type === 'force'){
                    this.showLoadingMask('课表信息还原中，请稍候...');
                }

                await this.$api.timetableManage.arrange.initUsedOrderInfo({
                    data: {
                        type: type,
                        semesterCode: this.curSemesterCode,
                    }
                }).then(response => {
                    if(type === 'manual'){
                        showNotify('成功', '重置成功', 'success', 1500);
                    }
                }).catch(error => {
                    if(type === 'manual'){
                        showNotify('错误', error, 'error', 3000);
                    }
                }).finally(() => {
                    if(type==='manual' || type==='auto' || type==='force'){
                        this.closeLoadingMask();
                    }
                });
            },
            async queUsedOrderInfo(){
                let isSuccess = false;

                await this.$api.timetableManage.arrange.queUsedOrderInfo({
                    data: this.usedOrderQueryInfo
                }).then(response => {
                    if(response.data.data.state == 'success'){
                        this.teaUsedOrderInfo = commonTools.parseUsedOrderInfo(this.queryForm.classCode, response.data.data.teaUsedInfo, this.semesterBaseParams.timeOrderInfo, null);
                        this.siteUsedOrderInfo = commonTools.parseUsedOrderInfo(this.queryForm.classCode, response.data.data.siteUsedInfo, this.semesterBaseParams.timeOrderInfo, null);
                        this.mergeClassSetInfo = commonTools.parseMergeClassConfigInfo(response.data.data.mergeClassConfig);
                        this.mergeClassCourseInfo = commonTools.parseMergeClassCourseInfo(response.data.data.mergeClassInfo);
                        this.handleMergeClassTitleInfo();

                        isSuccess = true;
                    }else{
                        isSuccess = false;
                        this.alertMsg(response.data.data.msg);
                    }
                }).catch(error => {
                    isSuccess = false;
                    console.log(error);
                });

                return isSuccess;
            },
            handleMergeClassTitleInfo(){
                //为合班课程添加提示信息
                for(let i=0; i<this.mergeClassCourseInfo.length; i++){
                    let curTimeOrder = this.mergeClassCourseInfo[i].timeOrder;
                    const index = (parseInt(curTimeOrder.substring(0, 2), 10)-1)*this.semesterBaseParams.totalNum + parseInt(curTimeOrder.substring(2), 10) - 1;
                    const curCellInfo = this.timetableInfo[index];

                    //判断单元格是否有内容
                    if(curCellInfo.planCode != ''){
                        let cellPlanCodeArray = curCellInfo.planCode.split(this.separator);
                        let mergeClassPlanCodeArray = this.mergeClassCourseInfo[i].planCode;

                        //判断当前单元格内课程是否为合班课程
                        for(let j=0; j<cellPlanCodeArray.length; j++){
                            for(let k=0; k<this.mergeClassSetInfo.length; k+=3){
                                let mergeConfigPlanCodeArray = this.mergeClassSetInfo[k].planCode;

                                if(mergeConfigPlanCodeArray.indexOf(cellPlanCodeArray[j])>-1 && mergeConfigPlanCodeArray.indexOf(mergeClassPlanCodeArray[0])>-1){
                                    let tempTitle = $('#' + this.timetableCellPrefix + index).attr('title');

                                    //删除原合班提示信息
                                    var tipsIndex = tempTitle.indexOf('\n\n该节课程为合班课程');
                                    if(tipsIndex > -1){
                                        tempTitle = tempTitle.substring(0, tipsIndex);
                                    }

                                    if(tempTitle.indexOf('固排课程')<0 && tempTitle.indexOf('\n\n')>-1){
                                        tempTitle += '\n';
                                    }else{
                                        tempTitle += '\n\n';
                                    }

                                    let finalTitle = tempTitle + '该节课程为合班课程（' + this.mergeClassCourseInfo[i].className + '  ' + this.mergeClassCourseInfo[i].courseName + '）';
                                    $('#' + this.timetableCellPrefix + index).attr('title', finalTitle);
                                }
                            }
                        }
                    }
                }
            },
            async resetUsedOrderInfo(type){
                await this.initUsedOrderInfo('force');

                if(type == 'destroy'){
                    /**关闭或刷新页面*/
                    this.handleLockState('all', 'unlock');
                }
            },
            verifyLockState(){
                this.$api.timetableManage.arrange.verifyLockState({
                    data: {
                        semesterCode: this.queryForm.semesterCode,
                        classCode: this.queryForm.classCode,
                    }
                }).then(response => {
                    const state = response.data.data.state;

                    //判断是否有教师正在排课
                    if(state == 'autoLocked'){
                        this.lockedState = true;

                        let msgStr = response.data.data.autoArrangeTeaName + '正在使用自动排课功能'
                        msgStr = '\n已用时间:' + response.data.data.autoArrangeTime;
                        //msgStr += '\n联系方式:' + response.data.data.autoArrangeTeaTel;
                        msgStr += '\n\n为保证排课的正确性，您目前只能查看课程表，请稍后再进行排课操作！';
                        this.$alert(msgStr, '提示', {
                            confirmButtonText: '确定',
                        });
                    }else if(state == 'manualLocked'){
                        this.lockedState = true;

                        this.$alert('当前班级的课表正有老师在操作，您目前只能查看课程表，请稍后再进行排课操作！', '提示', {
                            confirmButtonText: '确定',
                        });
                    }else{
                        this.lockedState = false;
                        this.handleLockState('manual', 'lock');
                    }
                }).catch(error => {
                    console.log(error);
                });
            },
            handleLockState(type, state){
                this.$api.timetableManage.arrange.handleLockState({
                    data: {
                        type: type,
                        state: state,
                        semesterCode: this.queryForm.semesterCode,
                        classCode: this.queryForm.classCode,
                    }
                }).then(response => {
                }).catch(error => {
                    console.log(error);
                });
            },
            alertMsg(str){
                this.$message({
                    message: str,
                    type: 'warning'
                });
            },
            //显示loading
            showLoadingMask(str) {
                this.loadingMask = this.$loading({
                    lock: true,
                    text: str,
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.8)",
                });
            },
            //关闭loading
            closeLoadingMask() {
                if (this.loadingMask) this.loadingMask.close();
            },
        },
    }
</script>
<style scoped>
    .main-container {
        moz-user-select: -moz-none;
        -moz-user-select: none;
        -o-user-select: none;
        -khtml-user-select: none; /* you could also put this in a class */
        -webkit-user-select: none;/* and add the CSS class here instead */
        -ms-user-select: none;
        user-select: none;/**禁止选中文字*/
    }

    #timetable-container .el-main {
        padding: 0;
    }

    #tree-container .el-tree {
        display: inline-block;
    }

    #tree-container /deep/ .el-tree__empty-block {
        position: absolute !important;
        width: 240px !important;
    }

    #timetable-area {
        border-left: 1px solid #DCDFE6;
        border-bottom: 1px solid #DCDFE6;
        overflow-x: auto;
        overflow-y: scroll;
    }

    .timetable {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        text-align: center;
    }

    .timetableHead {
        border-left: 1px solid #DCDFE6;
        border-top: 1px solid #DCDFE6;
        width: calc(100% - 17px);
        margin-top: 10px;
    }

    .timetable tr {
        height: 62.5px;
    }

    .timetableHead tr {
        height: 50px;
    }

    .timetable td {
        border-right: 1px solid #DCDFE6;
        border-bottom: 1px solid #DCDFE6;
        padding: 0;
    }

    .cellTitle {
        background-color: #F1FAF6;
        font-weight: bold;
        color: #4e5053;
    }

    .timetableContent {
        font-size: 14px;
        color: #4e5053;
        cursor: pointer;
    }

    .separetor {
        border-bottom: 4px double #DCDFE6 !important;
    }

    #rightButtonMenu {
        width: 150px;
        height: 40px;
        background-color: rgba(0, 0, 0, 0.5);
        position: absolute;
        top: -150px;
        left: -40px;
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .blueFont {
        color: blue;
    }
</style>



// WEBPACK FOOTER //
// experimentTimetable.vue?3d69c472